export default {
  getBillOrderInfo: {
    url: '/index/info/getBillOrderInfo',
    method: 'get',
  },
  getFinanceOrderInfo: {
    url: '/index/info/getFinanceOrderInfo',
    method: 'get',
  },
  getNotice: {
    url: '/notice/gets',
    method: 'post',
  },
  confirmNotice: {
    url: '/notice/confirm',
    method: 'post',
  },
};